import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { isNoneLinkedEntityId, linkedEntityIdsEqual, normalizeLinkedEntityId } from '../../..';
export var Headings = /*#__PURE__*/function () {
  function Headings() {
    _classCallCheck(this, Headings);
  }

  _createClass(Headings, null, [{
    key: "sortWithQuestions",
    value:
    /**
     * Interleave headings into a question list.
     *
     * Question order always follows the `previousQuestionId` linked list (caller should
     * pass already-sorted questions). Headings are woven in by their
     * nextQuestionId / previousQuestionId anchors so stale heading pointers cannot
     * reorder or drop questions.
     */
    function sortWithQuestions(headings, questions) {
      if (!headings || headings.length === 0) {
        return questions;
      }

      if (!questions || questions.length === 0) {
        return this.sort(headings);
      }

      var output = [];
      var usedHeadingIds = new Set();

      var placeHeading = function placeHeading(heading) {
        var id = heading.id.toString();
        if (usedHeadingIds.has(id)) return;
        usedHeadingIds.add(id);
        output.push(heading);
      };

      this.placeLeadingHeadingChain(headings, normalizeLinkedEntityId(questions[0].id.toString()), placeHeading);

      var _loop = function _loop(i) {
        var question = questions[i];
        var questionId = normalizeLinkedEntityId(question.id.toString());
        var previousQuestionId = i > 0 ? normalizeLinkedEntityId(questions[i - 1].id.toString()) : null;

        if (previousQuestionId) {
          headings.forEach(function (heading) {
            if (linkedEntityIdsEqual(heading.previousQuestionId, previousQuestionId)) {
              placeHeading(heading);
            }
          });
        }

        headings.forEach(function (heading) {
          if (linkedEntityIdsEqual(heading.nextQuestionId, questionId)) {
            placeHeading(heading);
          }
        });
        output.push(question);
      };

      for (var i = 0; i < questions.length; i++) {
        _loop(i);
      }

      var lastQuestionId = normalizeLinkedEntityId(questions[questions.length - 1].id.toString());
      headings.forEach(function (heading) {
        if (linkedEntityIdsEqual(heading.previousQuestionId, lastQuestionId)) {
          placeHeading(heading);
        }
      });
      var leftovers = headings.filter(function (heading) {
        return !usedHeadingIds.has(heading.id.toString());
      });

      if (leftovers.length > 0) {
        this.sort(leftovers).forEach(placeHeading);
      }

      return output;
    }
    /**
     * Same interleave as form-edit: sort headings and questions inside one section,
     * then weave headings into the question list.
     */

  }, {
    key: "sortBySectionWithQuestions",
    value: function sortBySectionWithQuestions(headings, questions, sectionId) {
      var sectionQuestions = (questions || []).filter(function (question) {
        return question.sectionId === sectionId;
      });
      var sectionHeadings = this.sort((headings || []).filter(function (heading) {
        return heading.sectionId === sectionId;
      }));
      return this.sortWithQuestions(sectionHeadings, sectionQuestions);
    }
  }, {
    key: "placeLeadingHeadingChain",
    value: function placeLeadingHeadingChain(headings, firstQuestionId, placeHeading) {
      var isNone = function isNone(id) {
        return isNoneLinkedEntityId(id);
      };

      var sitsAfterFirstQuestion = function sitsAfterFirstQuestion(heading) {
        return linkedEntityIdsEqual(heading.previousQuestionId, firstQuestionId);
      };

      var heads = headings.filter(function (heading) {
        return isNone(heading.previousHeadingId);
      });
      var start = heads.find(function (head) {
        var current = head;
        var seen = new Set();

        var _loop2 = function _loop2() {
          seen.add(current.id.toString());

          if (sitsAfterFirstQuestion(current)) {
            return {
              v: false
            };
          }

          if (linkedEntityIdsEqual(current.nextQuestionId, firstQuestionId)) {
            return {
              v: true
            };
          }

          if (!isNone(current.nextQuestionId)) {
            return {
              v: false
            };
          }

          if (isNone(current.nextHeadingId)) {
            return {
              v: true
            };
          }

          var nextId = current.nextHeadingId;
          current = headings.find(function (heading) {
            return heading.id.toString() === nextId;
          });
        };

        while (current && !seen.has(current.id.toString())) {
          var _ret = _loop2();

          if (typeof _ret === "object") return _ret.v;
        }

        return false;
      });

      if (!start) {
        return;
      }

      var current = start;
      var seen = new Set();

      var _loop3 = function _loop3() {
        seen.add(current.id.toString());

        if (sitsAfterFirstQuestion(current)) {
          return "break";
        }

        if (!isNone(current.nextQuestionId) && !linkedEntityIdsEqual(current.nextQuestionId, firstQuestionId)) {
          return "break";
        }

        placeHeading(current);

        if (linkedEntityIdsEqual(current.nextQuestionId, firstQuestionId)) {
          return "break";
        }

        if (isNone(current.nextHeadingId)) {
          return "break";
        }

        var nextId = current.nextHeadingId;
        current = headings.find(function (heading) {
          return heading.id.toString() === nextId;
        });
      };

      while (current && !seen.has(current.id.toString())) {
        var _ret2 = _loop3();

        if (_ret2 === "break") break;
      }
    }
  }, {
    key: "findNextHeadingIdWithPreviousQuestionId",
    value: function findNextHeadingIdWithPreviousQuestionId(headings, questionId) {
      return headings.find(function (h) {
        return linkedEntityIdsEqual(h.previousQuestionId, questionId);
      });
    }
  }, {
    key: "findPreviousHeadingWithNextQuestionId",
    value: function findPreviousHeadingWithNextQuestionId(headings, questionId) {
      return headings.find(function (h) {
        return linkedEntityIdsEqual(h.nextQuestionId, questionId);
      });
    }
  }, {
    key: "findNearestPreviousQuestionWithItemId",
    value: function findNearestPreviousQuestionWithItemId(itemId, questions, headings) {
      var questionsWithHeadings = Headings.sortWithQuestions(headings, questions);
      var findItemIndex = questionsWithHeadings.findIndex(function (ob) {
        return ob.id.toString() === itemId;
      });

      if (findItemIndex === -1) {
        return null;
      }

      for (var i = findItemIndex - 1; i >= 0; i--) {
        var formItem = questionsWithHeadings[i];

        if (formItem.type !== 'heading') {
          return formItem;
        }
      }

      return null;
    }
  }, {
    key: "findNearestPreviousHeadingWithItemId",
    value: function findNearestPreviousHeadingWithItemId(itemId, questions, headings, isHeadingItem) {
      var foundHeading = isHeadingItem ? headings.find(function (q) {
        return q.id.toString() === itemId;
      }) : questions.find(function (q) {
        return q.id.toString() === itemId;
      });
      if (!foundHeading) return null;
      var questionsWithHeadings = Headings.sortWithQuestions(headings.filter(function (h) {
        return h.sectionId === foundHeading.sectionId;
      }), questions.filter(function (q) {
        return q.sectionId === foundHeading.sectionId;
      }));
      var findItemIndex = questionsWithHeadings.findIndex(function (ob) {
        return ob.id.toString() === itemId;
      });

      if (findItemIndex === -1) {
        return null;
      }

      for (var i = findItemIndex - 1; i >= 0; i--) {
        var formItem = questionsWithHeadings[i];

        if (formItem.type === 'heading') {
          return formItem;
        }
      }

      return null;
    }
  }, {
    key: "findNearestNextHeadingWithItemId",
    value: function findNearestNextHeadingWithItemId(itemId, questions, headings, isHeadingItem) {
      var foundHeading = isHeadingItem ? headings.find(function (q) {
        return q.id.toString() === itemId;
      }) : questions.find(function (q) {
        return q.id.toString() === itemId;
      });
      if (!foundHeading) return null;
      var questionsWithHeadings = Headings.sortWithQuestions(headings.filter(function (h) {
        return h.sectionId === foundHeading.sectionId;
      }), questions.filter(function (q) {
        return q.sectionId === foundHeading.sectionId;
      }));
      var findItemIndex = questionsWithHeadings.findIndex(function (ob) {
        return ob.id.toString() === itemId;
      });

      if (findItemIndex === -1) {
        return null;
      }

      for (var i = findItemIndex; i < questionsWithHeadings.length; i++) {
        var formItem = questionsWithHeadings[i];

        if (formItem.type === 'heading' && formItem.id.toString() !== itemId) {
          return formItem;
        }
      }

      return null;
    }
  }, {
    key: "sort",
    value: function sort(headings) {
      var sortedHeadings = [];
      var usedIds = new Set();
      var headOfHeading = headings.find(function (heading) {
        return isNoneLinkedEntityId(heading.previousHeadingId);
      });

      if (headOfHeading) {
        sortedHeadings.push(headOfHeading);
        usedIds.add(headOfHeading.id.toString());
      }

      var currentHeadingId = headOfHeading === null || headOfHeading === void 0 ? void 0 : headOfHeading.id.toString();
      headings.forEach(function () {
        var nextHeading = headings.find(function (heading) {
          return linkedEntityIdsEqual(heading.previousHeadingId, currentHeadingId) && !usedIds.has(heading.id.toString());
        });

        if (!nextHeading) {
          return;
        }

        sortedHeadings.push(nextHeading);
        usedIds.add(nextHeading.id.toString());
        currentHeadingId = nextHeading.id.toString();
      });
      headings.forEach(function (heading) {
        var id = heading.id.toString();

        if (!usedIds.has(id)) {
          sortedHeadings.push(heading);
          usedIds.add(id);
        }
      });
      return sortedHeadings;
    }
  }]);

  return Headings;
}();